import React from 'react';
import { translate } from 'react-i18next';

import Form from './Form';
import * as API from '../../core/api';
import { catchFormErrors } from '../../utils/form-errors';
import i18n from '../../core/i18n';

class Create extends React.Component {
  handleSubmit = (formValues) => {
    const { onSuccess, type } = this.props;

    return API.post('projects', {
      ...formValues,
      urls:
        formValues.urls &&
        formValues.urls
          .split(',')
          .map((url) => url.trim())
          .filter((url) => url),
      type,
    })
      .then((user) => {
        const isAvatarSelected = typeof formValues.logoUrl === 'object';
        if (!isAvatarSelected) {
          return user;
        }

        const data = new FormData();
        data.append('avatar', formValues.logoUrl, formValues.logoUrl.name);

        // Find user's last project. BE CAREFUL, because if API sorting changes,
        // then - this logic will be obsolete.
        const projectId = user.projects[user.projects.length - 1].project._id;

        // If logo upload only fails, resolve the promise as a success,
        // but notify the user there was an issue.
        return new Promise((resolve, reject) => {
          API.post(`projects/${projectId}/logo`, data)
            .then((updatedProject) => {
              // Manually update project logo with the one coming from the API
              user.projects.find(
                ({ project }) => project._id === projectId
              ).project.logoUrl = updatedProject.logoUrl;

              resolve(user);
            })
            .catch((err) => {
              alert(
                i18n.t('project.create.avatarUploadEdgeCase', {
                  error: JSON.stringify(err),
                })
              );
              resolve(user);
            });
        });
      })
      .then(onSuccess)
      .catch(catchFormErrors);
  };

  render() {
    const { t } = this.props;

    return (
      <Form
        okButtonText={t('project.create.addBtn')}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

export default translate()(Create);



// WEBPACK FOOTER //
// ./src/projects/create/index.js